import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/VolumeLevel2.svg'

export const IconVolumeLevel2 = IconSVG as IconComponent
